<div class="wrapper d-flex align-items-stretch">
  <!-- Left Sidebar with Categories -->
  <ozm-sidebar (categorySelected)="onCategorySelected($event)"></ozm-sidebar>

  <!--PageContent-->
  <div id="content" class="p-4 p-md-5">
      <div class="top-wr">
       <ozm-header></ozm-header>
       
       <!-- Main Content Area -->
       <div class="container">
          <!-- Welcome Section when no category selected -->
          <div *ngIf="!selectedCategory" class="row manage-upper-sec">
              <div class="col-md-7">
                  <h1>
                      Explore your apps <br/>
                      with Osmlabs
                  </h1>
                  <p>All in One Apps and Deals</p>
                  <p class="instruction-text">👈 Select a category from the sidebar to browse apps</p>
                  <a class="download-btn" href="#">DOWNLOAD</a>
              </div>

              <div class="col-md-5">
                  <div class="right-mobile">
                      <img src="/assets/images/mobile.png"/>
                  </div>
              </div>
          </div>
          
          <!-- Selected Category Apps Display -->
          <div *ngIf="selectedCategory" class="category-apps-section">
              <div class="category-header">
                  <h1>
                      <i [class]="selectedCategory.icon" *ngIf="selectedCategory.icon?.startsWith('fa ')"></i>
                      {{ selectedCategory.name }}
                  </h1>
                  <div class="app-count">{{ selectedCategory.apps.length }} apps</div>
              </div>
              
              <!-- Apps Grid -->
              <div *ngIf="selectedCategory.apps.length > 0" class="apps-grid">
                  <div 
                      *ngFor="let app of selectedCategory.apps" 
                      class="app-card"
                      (click)="openApp(app)">
                      
                      <img 
                          [src]="getAppIconUrl(app)" 
                          (error)="handleImageError($event)"
                          [alt]="app.name"
                          class="app-image">
                      
                      <div class="app-details">
                          <h5 class="app-name">{{ app.name }}</h5>
                          <p class="app-description">{{ app.subCategory }}</p>
                          
                          <div class="app-badges">
                              <span *ngIf="app.default" class="badge badge-primary">Default</span>
                              <span *ngIf="app.openByPackageName" class="badge badge-success">Mobile</span>
                          </div>
                      </div>
                  </div>
              </div>
              
              <!-- No Apps Message -->
              <div *ngIf="selectedCategory.apps.length === 0" class="no-apps">
                  <h3>No apps available</h3>
                  <p>This category doesn't have any apps yet.</p>
          </div>
       </div>       
      </div>

      <!-- Most Used Apps Section (shown when no category selected) -->
      <div class="container" *ngIf="!selectedCategory">
          <div class="row">
              <div class="col-md-12">
                  <div class="most-use-heading">
                      <h1>Most Used App</h1>
                  </div>
                  <div class="most-use-app" id="offer">
                      <!-- Loading State -->
                      <div *ngIf="mostUsedLoading" class="text-center">
                          <div class="spinner-border text-primary" role="status">
                              <span class="sr-only">Loading...</span>
                          </div>
                          <p>Loading most used apps...</p>
                      </div>

                      <!-- Most Used Apps from Click Tracking -->
                      <ul *ngIf="!mostUsedLoading && mostUsedApps.length > 0">
                          <li *ngFor="let app of mostUsedApps">
                              <a (click)="openMostUsedApp(app)" style="cursor: pointer;">
                                  <img 
                                  class="use-app"
                                  [src]="getMostUsedAppIcon(app)"
                                  (error)="handleImageError($event)"
                                  [title]="app.name + ' (' + app.clickCount + ' clicks)'"
                                  [alt]="app.name">
                                  <span class="click-badge">{{ app.clickCount }}</span>
                              </a>
                          </li>
                      </ul>

                      <!-- Fallback to Default Apps if No Data -->
                      <ul *ngIf="!mostUsedLoading && mostUsedApps.length === 0">
                          <li>
                              <a href="https://www.facebook.com/" target="_blank">
                                  <img 
                                  class="use-app"
                                  src="/assets/images/fblogo.png"
                                  title="Facebook"
                                  alt="facebook">
                              </a>
                          </li>
                          <li>
                              <a href="https://www.facebook.com/" target="_blank">
                                  <img 
                                  class="use-app"
                                  src="/assets/images/messengerlogo.png"
                                  title="Messenger"
                                  alt="messenger">
                              </a>
                          </li>
                          <li>
                              <a href="https://www.amazon.in/" target="_blank">
                                  <img 
                                  class="use-app"
                                  src="/assets/images/amazonlogo.png"
                                  title="Amazon"
                                  alt="amazon">
                              </a>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>

      

      <div class="container" *ngIf="!selectedCategory">
          <div class="row">
              <div class="col-md-12">
                  <div class="most-use-heading">
                      <h1>Features</h1>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-md-3 col-sm-6">
                  <div class="Features-sec">
                      <img src="/assets/images/mobile-c.png" alt="mobile"/>
                      <h2>Best Offers</h2>
                      <p>Get the best offers for all your needs!!</p>
                  </div>
              </div>

              <div class="col-md-3 col-sm-6">
                  <div class="Features-sec">
                      <img src="/assets/images/camera-c.png" alt="camera">
                      <h2>Personalize</h2>
                      <p>Customize apps as per your requirement!!</p>
                  </div>
              </div>

              <div class="col-md-3 col-sm-6">
                  <div class="Features-sec">
                      <img src="/assets/images/secure-c.png" alt="secure">
                      <h2>Safe & Secure</h2>
                      <p>Personal data is not captured or stored!!</p>
                  </div>
              </div>

              <div class="col-md-3 col-sm-6">
                  <div class="Features-sec">
                      <img src="/assets/images/flex-c.png" alt="flexible">
                      <h2>Flexible to use</h2>
                      <p>Apps are grouped for Convenience!!</p>
                  </div>
              </div>
          </div>
      </div>
      
      <!-- Cashback Section -->
      <div class="container" *ngIf="!selectedCategory" id="Cashback">
          <div class="row">
              <div class="col-md-12">
                  <div class="most-use-heading">
                      <h1>Cashback & Rewards</h1>
                  </div>
              </div>
          </div>
          <div class="row cashback-section">
              <div class="col-md-6">
                  <div class="cashback-info">
                      <h2>Earn Cashback on Every Purchase!</h2>
                      <p>Shop through our partner apps and earn cashback rewards. It's that simple!</p>
                      <ul class="cashback-benefits">
                          <li><i class="fas fa-check-circle"></i> Up to 10% cashback on purchases</li>
                          <li><i class="fas fa-check-circle"></i> Instant rewards on selected apps</li>
                          <li><i class="fas fa-check-circle"></i> Track your earnings in real-time</li>
                          <li><i class="fas fa-check-circle"></i> Easy withdrawal options</li>
                      </ul>
                      <button class="btn-cashback" routerLink="/cashback">
                          <i class="fas fa-wallet"></i> View My Cashback
                      </button>
                  </div>
              </div>
              <div class="col-md-6">
                  <div class="cashback-illustration">
                      <img src="/assets/images/cashback-illustration.png" alt="Cashback" 
                           onerror="this.src='/assets/images/mobile.png'"/>
                  </div>
              </div>
          </div>
      </div>

      <div class="container" *ngIf="!selectedCategory" id="Feedback">
          <div class="row">
              <div class="col-md-12">
                  <div class="most-use-heading">
                      <h1>Feedback</h1>
                  </div>

                  <div class="feedback-head-text">
                      <h2>Send us your feedback</h2>
                      <p>Do you have a suggestion? <br>
                         let us know in the field below</p>
                  </div>
              </div>
          </div>
      </div>

      <div class="form-color-bg" *ngIf="!selectedCategory">
          <div class="container">
              <div class="row">
                  <div class="feedback-form-bg">
                      <form onsubmit="return false;" [formGroup]="feedbackFormGroup" (ngSubmit)="onSubmit()">
                          <p class="labelish">Feedback type</p>
                          <div name="paymentContainer" class="form-text-wr">

                              <div class="floatBlock">
                                  <label id ="">
                                      <input 
                                      name="feedbackType" 
                                      formControlName="feedbackType"
                                      type="radio" 
                                      value="feedback offer"
                                      /> Feedback Offer
                                  </label>
                              </div>

                              <div class="floatBlock">
                                  <label id ="">
                                      <input name="feedbackType" formControlName="feedbackType"
                                       type="radio" value="req. an app"/> Require an App?
                                  </label>
                              </div>

                              <div class="floatBlock">
                                  <label id ="">
                                      <input name="feedbackType" formControlName="feedbackType"
                                       type="radio" value="other feedback"/> Other Feedback
                                  </label>
                              </div>
                              
                          </div>

                          <p class="message-text-line">Please tell us your views about website and how to improve it</p>
                          <textarea formControlName="reviewComment"
                              class="message-area">
                          </textarea>

                          <div class="form-btn">
                              <button type="submit" class="btn-feedback">Send Feedback</button>
                          </div>

                      </form>

                  </div>
              </div>
          </div>
      </div>

      <div class="container" *ngIf="!selectedCategory" id="Contact-us">
          <div class="row">
              <div class="col-md-12">
                  <div class="most-use-heading">
                      <h1>Contact Us</h1>
                  </div>
                  
                  <div class="contact-email">
                      <img src="/assets/images/email-c.png" alt="email">
                      <span>contact@ozmlabs.com</span>
                  </div>
              </div>
          </div>
      </div>

  </div>
</div>